const calculateMass = ({ width, height, length }) => {
  const value = (width * height * length) / 6000;

  return (
    Math.round((isNaN((width * height * length) / 6000) ? 0 : value) * 100) /
    100
  );
};

export default calculateMass;
